import React from "react";
import resolveLink from "src/utils/resolveLink";
import Label from "src/components/Label";

const Share = ({ currentUrl, title }) => {
  const url = resolveLink(currentUrl);
  return (
    <div className="py-12 lg:py-16">
      <Label className="text-teal mx-auto text-center !font-normal">
        Share:
      </Label>
      <div className="flex flex-row items-center justify-center space-x-4 text-base">
        <a
          href={`https://www.facebook.com/sharer.php?u=https://govox.com${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <i class="fa-brands fa-facebook hover:text-teal duration-300"></i>
        </a>
        <a
          href={`https://twitter.com/share?url=https://govox.com${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <i class="fa-brands fa-twitter hover:text-teal duration-300"></i>
        </a>
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=https://govox.com${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <i class="fa-brands fa-linkedin-in hover:text-teal duration-300"></i>
        </a>
        <a
          href={`mailto:?subject=${title}&body=Check out this article on Govox: https://govox.com${url}`}
        >
          <i class="fa-regular fa-envelope hover:text-teal duration-300"></i>
        </a>
      </div>
    </div>
  );
};

export default Share;
